/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-properties */
/* eslint-disable prefer-exponentiation-operator */
import React, { useEffect, useState } from 'react';
import { useT } from 'talkr';
import s from './bmiResultBlock.module.scss';

import triangleBlack from './img/triangle_black.svg';
import triangle from './img/triangle.svg';

const MIN_VALUE = 15;
const MAX_VALUE = 40;

// eslint-disable-next-line no-nested-ternary
const inRange = (value) => (value < MIN_VALUE
	? MIN_VALUE
	: value > MAX_VALUE
		? MAX_VALUE
		: value);

const OUT_POSITION_CLASS_NAME = {
	left: s.outPositionLeft,
	right: s.outPositionRight
};

function BmiResultBlock (props) {
	const { T } = useT();
	const bmiProgress = (props.weight / Math.pow(props.height / 100, 2)).toFixed(2);
	const left = (inRange(bmiProgress) - MIN_VALUE) / (MAX_VALUE - MIN_VALUE) * 100;
	let outPosition;

	const [hideCurrent, setHideCurrent] = useState(false);

	if (bmiProgress <= 16) outPosition = 'left';
	if (bmiProgress >= 40) outPosition = 'right';

	if (bmiProgress >= 19.7 && bmiProgress <= 26 && hideCurrent !== true) setHideCurrent(true);

	let titleText = window.locales.bmi;

	if (hideCurrent) titleText = `${titleText} - ${bmiProgress}`;

	function checkPointsIntersections () {
		setHideCurrent(false);
		const rect1 = document.querySelector('#currentValue') && document.querySelector('#currentValue').getBoundingClientRect();
		if (!rect1) return;
		const rect2 = document.querySelector('#goalValue').getBoundingClientRect();

		if (rect1.top + rect1.height > rect2.top &&
      rect1.left + rect1.width > rect2.left &&
      rect1.bottom - rect1.height < rect2.bottom &&
      rect1.right - rect1.width < rect2.right) {
			setHideCurrent(true);
		} else {
			setHideCurrent(false);
		}
	}

	useEffect(() => {
		window.addEventListener('resize', checkPointsIntersections);

		checkPointsIntersections();

		return () => {
			window.removeEventListener('resize', checkPointsIntersections);
		};
	}, []);

	return (
		<div className={`${s.bmi} ${OUT_POSITION_CLASS_NAME[outPosition]}`}>
			<h2 className={s.title}>{titleText}</h2>
			<div className={s.bmiGrafic}>
				<div className={s.graficLineWrapper}>
					<div className={s.graficLine}>
						<span />
						<span />
						<span />
						<span />
					</div>
				</div>
				<div className={s.graficPointer}>
					{!hideCurrent && (
						<div className={`${s.pointer}`} style={{ left: `${left}%` }}>
							<div className={`${s.point} ${s.current}`} id="currentValue">
								<div className={`${s.currentValue} ${s.currentPoint}`}>
									{T('bmi_current')} ({(+bmiProgress).toFixed(0)})
								</div>
								<img className={s.icon} src={triangleBlack} alt="" />
							</div>
						</div>
					)}
					<div className={`${s.pointer} ${s.goal}`}>
						<div className={`${s.point} ${s.current}`} id="goalValue">
							<div className={`${s.currentValue} ${s.goalValue}`}>
								{T('bmi_goal')} (22)
							</div>
							<img className={s.icon} src={triangle} alt="" />
						</div>
					</div>
				</div>
				<div className={s.graficValues}>
					<span>{MIN_VALUE}</span>
					<span>18.5</span>
					<span>25</span>
					<span>30</span>
					<span>{MAX_VALUE}</span>
				</div>
			</div>
		</div>
	);
}

export default BmiResultBlock;
